import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DropdownArrow, DropdownUpArrow, DashboardEdit, DashboardExpand, } from "../../../assets/icons";
import "../dashboard-mergers-and-acquisitions/dashboard-mergers-and-acquisitions.scss";

const DealsButtonRow = ({ member, toggled, showModal, toggleAccordion, accordionId, setToggled, setCollapsed, getCollapsedStatus, juniorBankerView }) => {
    let isToggled = toggled?.filter(t => t.UserId == member.UserId)?.[0]?.Toggled ?? false;
    let allDisabled = member?.TableDeals?.length === 0;

    const commonButtons = (
      <React.Fragment>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Edit {member.DealsTaskName}</Tooltip>}
        >
          { !member.AllowDealsEdit ? (
            <img disabled alt="dropdown-arrow" src={DashboardEdit} />
          ) : (
            <div>
              <Link to={`/tasks/edit/std/${member.DealsTaskId}`} target="_blank" rel='noopener noreferrer'>
                <img disabled={!member.AllowDealsEdit} alt="dropdown-arrow" src={DashboardEdit} />
              </Link>
          </div>
          )}
        </OverlayTrigger>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Expand {member.DealsTaskName}</Tooltip>}
        >
          { !allDisabled ?
              <img alt="dropdown-arrow" src={DashboardExpand} onClick={() => showModal(member, 'deals')} />
            :
              <img disabled alt="dropdown-arrow" src={DashboardExpand} />
          }
        </OverlayTrigger>
      </React.Fragment>
    );

    if (allDisabled) {
      return (
        <td className="col-md-1 mt-2">
          <div className="mergers-button-row">
            {commonButtons}
            <img className="mergers-dropdown-arrow" disabled alt="dropdown-arrow" src={DropdownArrow} />
          </div>
        </td>
      );
    }
    return (
      <td className="col-md-1 mt-2 mergers-toogle">
        <div className="mergers-button-row">
          {commonButtons}
          <img className="mergers-dropdown-arrow"
            alt="dropdown-arrow"
            src={isToggled ? DropdownUpArrow : DropdownArrow}
            disabled={juniorBankerView}
            onClick={(e) => {
              if (juniorBankerView) return;
              let updatedToggled = toggled.map((t) => {
                if (t.UserId == member.UserId) t.Toggled = !isToggled;
                return t;
              });
              toggleAccordion(accordionId + "-" + member.UserId);
              setToggled(updatedToggled);
              setCollapsed(getCollapsedStatus(accordionId));
            }}
          />
        </div>
      </td>
    );
};

DealsButtonRow.propTypes = {
    member: PropTypes.shape({
        UserId: PropTypes.number.isRequired,
        TableDeals: PropTypes.array.isRequired,
        DealsTaskName: PropTypes.string.isRequired,
        AllowDealsEdit: PropTypes.bool,
        DealsTaskId: PropTypes.number.isRequired,
    }).isRequired,
    toggled: PropTypes.arrayOf(
        PropTypes.shape({
            UserId: PropTypes.number.isRequired,
            Toggled: PropTypes.bool.isRequired,
        })
    ).isRequired,
    showModal: PropTypes.func.isRequired,
    toggleAccordion: PropTypes.func.isRequired,
    accordionId: PropTypes.string.isRequired,
    setToggled: PropTypes.func.isRequired,
    setCollapsed: PropTypes.func.isRequired,
    getCollapsedStatus: PropTypes.func.isRequired,
    juniorBankerView: PropTypes.bool.isRequired,
};

export default DealsButtonRow;
